<form [formGroup]="formGroup" novalidate #form="ngForm">
  <div>
    <glxy-form-row>
      <glxy-form-field bottomSpacing="small" [showLabel]="false">
        <textarea
          #defaultInput
          formControlName="taskName"
          matInput
          placeholder="{{ 'ACTIVITY_LOGGER.LOGGED_TASK.TITLE_PLACEHOLDER' | translate }}"
          cdkTextareaAutosize
        ></textarea>
        @if (showErrors) {
          @if (formGroup.controls.taskName.hasError('required')) {
            <glxy-error>
              {{ 'ACTIVITY_LOGGER.ERROR_REQUIRE_TASK_NAME_REQUIRED' | translate }}
            </glxy-error>
          }
        }
      </glxy-form-field>
    </glxy-form-row>
    <glxy-form-row>
      <glxy-rich-text-editor
        class="rich-text-editor"
        elementId="task-rte"
        [statusbar]="true"
        [enableThemes]="true"
        [formControl]="formGroup.controls['taskInstructions']"
        [allowResize]="true"
        [plugins]="DEFAULT_RICH_TEXT_PLUGINS"
        [toolbar]="DEFAULT_RICH_TEXT_TOOLBAR"
      ></glxy-rich-text-editor>
      @if (showErrors) {
        <ng-container>
          @if (formGroup.controls.taskInstructions.hasError('maxLength')) {
            <glxy-error class="rich-text-error">
              {{ 'ACTIVITY_LOGGER.ERROR_MAX_LENGTH_EXCEEDED' | translate: { maxLength: ACTIVITY_BODY_MAX_LENGTH } }}
            </glxy-error>
          }
        </ng-container>
      }
    </glxy-form-row>
  </div>
  <ng-content select="[crmLoggerContent='after-description']"></ng-content>
  <div>
    <glxy-form-row class="detail-form-row" [class.mobile]="mobile">
      <glxy-form-field
        bottomSpacing="small"
        [showLabel]="false"
        size="default"
        class="detail-form-field"
        [class.mobile]="mobile"
        [prefixIcon]="'alarm'"
        >
        <input
          formControlName="taskDueDate"
          type="datetime-local"
          matInput
          placeholder="{{ 'ACTIVITY_LOGGER.LOGGED_TASK.DUE_DATE_PLACEHOLDER' | translate }}"
          />
        <mat-datepicker #taskDueDateInput></mat-datepicker>
        @if (showErrors) {
          @if (formGroup.controls.taskDueDate.hasError('required')) {
            <glxy-error>
              {{ 'ACTIVITY_LOGGER.ERROR_REQUIRE_TASK_DUE_DATE' | translate }}
            </glxy-error>
          }
        }
      </glxy-form-field>
      <glxy-form-field
        [prefixIcon]="'assignment_ind'"
        bottomSpacing="small"
        [showLabel]="false"
        class="detail-form-field"
        [class.mobile]="mobile"
        >
        <crm-form-field-activity-owner
          insideInputWrapper
          formControlName="taskOwner"
          placeholder="{{ 'ACTIVITY_LOGGER.LOGGED_TASK.OWNER_PLACEHOLDER' | translate }}"
          >
        </crm-form-field-activity-owner>
        @if (showErrors) {
          @if (formGroup.controls.taskOwner.hasError('required')) {
            <glxy-error>
              {{ 'ACTIVITY_LOGGER.ERROR_REQUIRE_TASK_ASSIGNEE' | translate }}
            </glxy-error>
          }
        }
      </glxy-form-field>
    </glxy-form-row>
    <glxy-form-row class="detail-form-row" [class.mobile]="mobile">
      <glxy-form-field
        [prefixIcon]="'checklist'"
        bottomSpacing="small"
        [showLabel]="false"
        class="detail-form-field"
        [class.mobile]="mobile"
        >
        <mat-select
          formControlName="taskType"
          placeholder="{{ 'ACTIVITY_LOGGER.LOGGED_TASK.TYPE_PLACEHOLDER' | translate }}"
          >
          @for (type of taskTypes$ | async; track type) {
            <mat-option [value]="type">
              {{ type }}
            </mat-option>
          }
        </mat-select>
        @if (showErrors) {
          @if (formGroup.controls.taskType.hasError('required')) {
            <glxy-error>
              {{ 'ACTIVITY_LOGGER.ERROR_REQUIRE_TASK_TYPE' | translate }}
            </glxy-error>
          }
        }
      </glxy-form-field>
      <glxy-form-field
        [prefixIcon]="'priority_high'"
        bottomSpacing="small"
        [showLabel]="false"
        class="detail-form-field"
        [class.mobile]="mobile"
        >
        <mat-select
          formControlName="taskPriority"
          placeholder="{{ 'ACTIVITY_LOGGER.LOGGED_TASK.PRIORITY_PLACEHOLDER' | translate }}"
          >
          @for (priority of taskPriorities$ | async; track priority) {
            <mat-option [value]="priority">
              {{ priority }}
            </mat-option>
          }
        </mat-select>
      </glxy-form-field>
    </glxy-form-row>
    <ng-content select="[crmLoggerContent='fields']"></ng-content>
  </div>
</form>
